import { ReactElement } from "react";
import "./ItemLoadProgress.scss"


type Props = {
  isLoading: boolean
  items: readonly any[]
  itemsName: string
  error: string | null
}

export function ItemLoadProgress(
  {isLoading, items, itemsName, error}: Props
):ReactElement {

  return <div className={"ItemLoadProgress " + (isLoading ? "loading" : "loaded") +
    (error ? " error" : "")}>
    Loading: {items.length} {itemsName}.... {!isLoading && "done"}
    {error && "error"}
  </div>
}
